"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = getAPIURL;

var _addVersion = _interopRequireDefault(require("./addVersion"));

/**
 * Returns the API URL for the given page
 * @param {String} pageURI The page URI
 * @return {String}
 */
function getAPIURL(pageURI) {
  var parsed = (0, _addVersion["default"])(pageURI);
  return '/api' + parsed.pathname.replace(/\/$/, '') + parsed.search;
}
//# sourceMappingURL=getAPIURL.js.map